/** Enum that holds reference Ids of the Entity types. */
export enum EntityTypeIdEnum {
  ORDER = 1,
  CART = 3,
  // TODO: Add other Entity types as required. Refer to Database table `entitytype`
}
